export default __webpack_public_path__ + "images/3d9fe2256d65eb4a4475e85d1744b283.svg";